(() => {
  if (window.chiqProductSystem) return;
  window.chiqProductSystem = true;
  function initialise(scope = document) {
    scope.querySelectorAll('[data-chiq-system]').forEach(root => {
      if (root.dataset.systemReady) return;
      root.dataset.systemReady = 'true';
      const dialog = root.querySelector('.chiq-system__lightbox');
      if (!dialog) return;
      let opener;
      root.addEventListener('click', event => {
        const button = event.target.closest('[data-chiq-zoom]');
        if (!button || !root.contains(button)) return;
        opener = button;
        const image = dialog.querySelector('img');
        image.src = button.dataset.chiqZoom;
        image.alt = button.dataset.chiqAlt || '';
        dialog.showModal();
        dialog.querySelector('button').focus();
      });
      dialog.querySelector('[data-system-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), {once:true});
  else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
